
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zaloguj",
      function () {
        return require("private-next-pages/zaloguj/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zaloguj"])
      });
    }
  